import classNames from 'classnames';
import { ComponentProps } from 'react';
import { Overlay, OverlayProps } from 'react-bootstrap';

type ProductOverlayProps = Pick<OverlayProps, 'target' | 'show'> &
  Pick<ComponentProps<'div'>, 'className' | 'style' | 'children'> & {
    onHide: () => void;
  };

export function ProductOverlay({ className, target, children, onHide, show }: ProductOverlayProps) {
  const close = (event: Event) => {
    if (event instanceof KeyboardEvent && event.key === 'Escape') {
      return;
    }
    onHide();
  };

  return (
    <Overlay show={show} target={target} placement="bottom" rootClose onHide={close}>
      {({
        placement: _placement,
        arrowProps: _arrowProps,
        show: _show,
        popper: _popper,
        hasDoneInitialMeasure: _hasDoneInitialMeasure,
        ...props
      }) => (
        <div
          {...props}
          style={{
            ...props.style,
            maxHeight: 300,
            width: (target as HTMLElement).offsetWidth,
            zIndex: 1000,
          }}
          className={classNames('card shadow-sm overflow-hidden h-100', className)}
        >
          {children}
        </div>
      )}
    </Overlay>
  );
}
